import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type {
  BackgroundColorProps,
  BorderColorProps,
  BorderStyleProps,
  BorderWidthProps,
  FontWeightProps,
  LineHeightProps,
} from 'styled-system';
import {
  backgroundColor,
  borderColor,
  borderStyle,
  borderWidth,
  color,
  fontWeight,
  lineHeight,
} from 'styled-system';

import { Flex } from 'common/components/Flex';
import type { BorderRadiusTL, BorderRadiusTR } from 'common/theme/system-utilities';
import { borderRadiusTL, borderRadiusTR } from 'common/theme/system-utilities';

const UnstyledContainer = styled(Flex)<
  BackgroundColorProps &
    BorderColorProps &
    BorderRadiusTL &
    BorderRadiusTR &
    BorderStyleProps &
    BorderWidthProps &
    FontWeightProps &
    LineHeightProps
>`
  ${backgroundColor};
  ${borderColor};
  ${borderRadiusTL};
  ${borderRadiusTR};
  ${borderStyle};
  ${borderWidth};
  ${color};
  ${fontWeight};
  ${lineHeight};
`;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer
    as="header"
    backgroundColor="sys.neutral.background.hover"
    borderColor="sys.neutral.background.weak"
    borderRadiusTL="medium"
    borderRadiusTR="medium"
    color="sys.neutral.text.strong"
    fontSize="fs_16"
    fontWeight={700}
    lineHeight="lh_20"
    px="sp_8"
    py="sp_16"
    {...props}
  />
);

interface ConfigurationCardHeaderProps {
  title: string;
}

const ConfigurationCardHeader = ({ title }: ConfigurationCardHeaderProps) => {
  return <Container>{title}</Container>;
};

export default ConfigurationCardHeader;
